<template>
  <div class="news-page">
    <div class="page-header">
      <div class="container">
        <h1>新闻动态</h1>
        <p>了解公司最新动态和行业资讯</p>
      </div>
    </div>
    
    <div class="container news-container">
      <div class="news-main">
        <div class="featured-news" @click="goToDetail(featuredNews.id || 1)">
          <div class="news-image">
            <img :src="featuredNews.image" :alt="featuredNews.title">
            <div class="news-date">{{ featuredNews.createTime }}</div>
          </div>
          <div class="news-content">
            <h2 class="news-title">{{ featuredNews.title }}</h2>
            <p class="news-summary">{{ featuredNews.summary }}</p>
          </div>
        </div>
        
        <div class="news-list">
          <div 
            class="news-item" 
            v-for="(news, index) in pagedNewsList" 
            :key="news.id || index"
            @click="goToDetail(news.id)"
          >
            <div class="item-date">{{ news.createTime }}</div>
            <div class="item-content">
              <h3>{{ news.title }}</h3>
              <p>{{ news.summary }}</p>
            </div>
          </div>
          <el-pagination
            v-if="newsList.length > pageSize"
            class="news-pagination"
            background
            layout="prev, pager, next"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="newsList.length"
            @current-change="handlePageChange"
          />
        </div>
      </div>
      
      <div class="news-sidebar">
        <div class="sidebar-section">
          <h3>热门资讯</h3>
          <ul class="hot-news">
            <li v-for="(item, index) in hotNews" :key="index" @click="goToDetail(item.id)">
              <span class="hot-number">{{ index + 1 }}</span>
              <a href="#" class="hot-title" @click.prevent>{{ item.title }}</a>
            </li>
          </ul>
        </div>
        
        <div class="sidebar-section">
          <h3>技术专栏</h3>
          <ul class="tech-news">
            <li v-for="(item, index) in techNews" :key="index" @click="goToDetail(item.id)">
              <a href="#" class="tech-title" @click.prevent>{{ item.title }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList, getHotNews, getTechNews } from '@/api/news'
export default {
  name: 'News',
  data() {
    return {
      loading: false,
      featuredNews: {},
      newsList: [],
      hotNews: [],
      techNews: [],
      currentPage: 1,
      pageSize: 5
    }
  },
  computed: {
    pagedNewsList() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.newsList.slice(start, start + this.pageSize)
    }
  },
  created() {
    this.fetchNewsData()
  },
  methods: {
    async fetchNewsData() {
      this.loading = true
      try {
        // 并行请求新闻列表、热门新闻、技术专栏
        const [newsRes, hotRes, techRes] = await Promise.all([
          getNewsList({ page: 1, pageSize: 10 }),
          getHotNews({ limit: 5 }),
          getTechNews({ limit: 5 })
        ])
        // 解析新闻列表：第一项作为头条新闻，其余作为列表
        const newsData = newsRes.data || newsRes
        const list = newsData || []
        if (list.length > 0) {
          this.featuredNews = {
            id: list[0].id,
            title: list[0].title,
            summary: list[0].summary,
            createTime: list[0].createTime,
            image: list[0].image || require('@/assets/images/home/banner_c1.jpg')
          }
          this.newsList = list.slice(1)
        }
        // 解析热门新闻
        this.hotNews = hotRes.data || hotRes || []
        // 解析技术专栏
        this.techNews = techRes.data || techRes || []
      } catch (error) {
        console.warn('新闻数据接口请求失败，使用默认数据:', error.message)
      } finally {
        this.loading = false
      }
    },
    handlePageChange(page) {
      this.currentPage = page
    },
    goToDetail(id) {
      this.$router.push(`/news/${id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.news-page {
  padding-top: 60px;
  
  .page-header {
    background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('../assets/images/news-banner.png');
    background-size: cover;
    background-position: center;
    height: 341px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    
    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
      
      h1 {
        font-size: 42px;
        margin-bottom: 15px;
        font-weight: 700;
      }
      
      p {
        font-size: 18px;
        opacity: 0.9;
      }
    }
  }
  
  .news-container {
    max-width: 1200px;
    margin: 50px auto;
    padding: 0 20px;
    display: flex;
    gap: 40px;
    
    .news-main {
      flex: 1;
      
      .featured-news {
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0,0,0,0.08);
        margin-bottom: 30px;
        
        .news-image {
          position: relative;
          height: 350px;
          overflow: hidden;
          
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
          }
          
          &:hover img {
            transform: scale(1.05);
          }
          
          .news-date {
            position: absolute;
            bottom: 15px;
            left: 15px;
            background: rgba(0,0,0,0.6);
            color: #fff;
            padding: 6px 15px;
            border-radius: 20px;
            font-size: 14px;
          }
        }
        
        .news-content {
          padding: 30px;
          
          .news-title {
            font-size: 24px;
            font-weight: 600;
            color: #2c3e50;
            text-decoration: none;
            line-height: 1.4;
            
            &:hover {
              color: #409eff;
            }
          }
          
          .news-summary {
            margin-top: 15px;
            color: #666;
            line-height: 1.8;
            font-size: 15px;
          }
        }
      }
      
      .news-list {
        background: #fff;
        border-radius: 12px;
        padding: 20px;
        box-shadow: 0 4px 20px rgba(0,0,0,0.08);
        
        .news-pagination {
          margin-top: 20px;
          text-align: center;
        }
        
        .news-item {
          display: flex;
          padding: 20px 0;
          border-bottom: 1px solid #eee;
          cursor: pointer;
          transition: all 0.3s ease;
          
          &:last-child {
            border-bottom: none;
          }
          
          &:hover {
            padding-left: 10px;
            background: #f8f9fa;
          }
          
          .item-date {
            flex-shrink: 0;
            width: 100px;
            text-align: center;
            padding: 10px;
            background: #f5f7fa;
            border-radius: 8px;
            font-size: 14px;
            color: #666;
            margin-right: 20px;
            
            @media screen and (max-width: 768px) {
              display: none;
            }
          }
          
          .item-content {
            flex: 1;
            
            h3 {
              font-size: 17px;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 8px;
              line-height: 1.4;
            }
            
            p {
              font-size: 14px;
              color: #999;
              line-height: 1.6;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
        }
      }
    }
    
    .news-sidebar {
      width: 320px;
      flex-shrink: 0;
      
      .sidebar-section {
        background: #fff;
        border-radius: 12px;
        padding: 25px;
        margin-bottom: 20px;
        box-shadow: 0 4px 20px rgba(0,0,0,0.08);
        
        h3 {
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 20px;
          padding-bottom: 15px;
          border-bottom: 2px solid #409eff;
          position: relative;
          
          &::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 0;
            width: 30px;
            height: 2px;
            background: #ff6b6b;
          }
        }
        
        .hot-news {
          list-style: none;
          padding: 0;
          margin: 0;
          
          li {
            display: flex;
            align-items: center;
            padding: 12px 0;
            border-bottom: 1px dashed #eee;
            
            &:last-child {
              border-bottom: none;
            }
            
            .hot-number {
              width: 24px;
              height: 24px;
              background: #f0f0f0;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 13px;
              font-weight: 600;
              color: #666;
              margin-right: 12px;
              flex-shrink: 0;
            }
            
            &:nth-child(1) .hot-number {
              background: #ff6b6b;
              color: #fff;
            }
            
            &:nth-child(2) .hot-number {
              background: #ff8c00;
              color: #fff;
            }
            
            &:nth-child(3) .hot-number {
              background: #ffd700;
              color: #fff;
            }
            
            .hot-title {
              font-size: 14px;
              color: #333;
              text-decoration: none;
              line-height: 1.4;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              transition: color 0.3s;
              
              &:hover {
                color: #409eff;
              }
            }
          }
        }
        
        .tech-news {
          list-style: none;
          padding: 0;
          margin: 0;
          
          li {
            padding: 12px 0;
            border-bottom: 1px dashed #eee;
            
            &:last-child {
              border-bottom: none;
            }
            
            .tech-title {
              font-size: 14px;
              color: #333;
              text-decoration: none;
              line-height: 1.5;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              transition: all 0.3s;
              
              &:hover {
                color: #409eff;
                padding-left: 5px;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .news-page {
    .news-container {
      flex-direction: column;
      
      .news-sidebar {
        width: 100%;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .news-page {
    .page-header {
      height: 300px;
      
      .container {
        h1 {
          font-size: 28px;
        }
        
        p {
          font-size: 16px;
        }
      }
    }
    
    .news-container {
      margin: 30px auto;
      gap: 25px;
      
      .news-main {
        .featured-news {
          .news-image {
            height: 220px;
          }
          
          .news-content {
            padding: 20px;
            
            .news-title {
              font-size: 20px;
            }
            
            .news-summary {
              font-size: 14px;
            }
          }
        }
        
        .news-list {
          padding: 15px;
          
          .news-item {
            padding: 15px 0;
            
            .item-content {
              h3 {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}
</style>